import React, { useEffect, useState } from "react";

import { Grid, Box } from "@mui/material";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@material-ui/core/styles';
// import TrainerDetailTable from "./TrainerDetailTable";
import TrainerBatchwiseTable from "./TrainerBatchwiseTable";

const BatchWiseUsageReport = (props) => {
    // Hooks
    const classes = useStyles();
    
    // console.log("batchWiseCourseData",props.batchWiseCourseData);
    //State
    const [tabValue, setTabValue] = useState('presentation');

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Grid container   sx={{ height: '68vh', overflow: 'auto', px: 1 }}>   
            <Grid item xs={12}>                
                <TabContext value={tabValue}>
                    <Box sx={{ display: 'inline-flex', borderBottom: 1, borderBlockColor: '#EFEFEF', justifyContent: 'center', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="API tabs"
                        >
                            <Tab 
                                label="Presentation"
                                value="presentation"
                                sx={{ textTransform: 'inherit', ml: 10, fontWeight: '600', color: '#7f97d8', fontSize: '1rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}
                            />                            
                        </TabList>
                    </Box>
                    <TabPanel value="presentation">                        
                        <TrainerBatchwiseTable
                            tableDetailData={props.batchWiseCourseData}
                            allClasses={props.allClasses}
                            tabValue={tabValue}
                        />
                    </TabPanel>                    
                </TabContext>
            </Grid>
        </Grid>
    );
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.5em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    }
});
export default BatchWiseUsageReport;